<!-- 
	This is the sign in page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
  <div class="company">
    <img class="sign_bg" src="@/assets/login_image.png" alt="" />

    <a-row type="flex" :gutter="[24, 24]" justify="space-around" align="middle">
      <a-col
        :span="24"
        :md="24"
        :lg="{ span: 16, offset: 0 }"
        :xl="{ span: 16, offset: 2 }"
        class="col-form"
      >
        <!-- 步骤条 -->
        <div style="margin-top: 12vh">
          <a-steps :current="current" :status="stepStatus">
            <a-step
              v-for="item in steps"
              :key="item.title"
              :title="item.title"
            />
          </a-steps>
        </div>

        <a-card
          :bordered="false"
          style="
            position: relative;
            border-radius: 20px;
            padding: 0 30px;
            margin-top: 80px;
            background-color: #ffffff98;
            overflow: auto;
            max-height: 58vh;
          "
        >
          <a-form class="login-form">
            <a-form-item
              class="mb-5"
              label="营业执照"
              required
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-upload
                :before-upload="beforeUpload"
                name="avatar"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                action=""
                :disabled="usrInfo.auditStatus != 1 && usrInfo.auditStatus != 4"
                @change="handleChange"
              >
                <img
                  style="height: 120px"
                  v-if="businessLicense"
                  :src="businessLicense"
                  alt="avatar"
                />
                <div v-else>
                  <a-icon :type="loading ? 'loading' : 'plus'" />
                  <div class="ant-upload-text">点击上传</div>
                </div>
              </a-upload>
            </a-form-item>
            <a-form-item
              class="mb-5"
              required
              label="统一社会信用码/注册号/组织机构代码"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                v-if="usrInfo.auditStatus == 1 || usrInfo.auditStatus == 4"
                v-model="creditCode"
                placeholder="请输入统一社会信用码/注册号/组织机构代码"
              />
              <div v-else>{{ creditCode || "--" }}</div>
            </a-form-item>
            <a-form-item
              class="mb-5"
              label="公司名称"
              required
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                v-if="usrInfo.auditStatus == 1 || usrInfo.auditStatus == 4"
                v-model="companyName"
                placeholder="请输入公司名称"
              />
              <div v-else>{{ companyName || "--" }}</div>
            </a-form-item>
            <a-form-item
              class="mb-5"
              label="法人名称"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                v-if="usrInfo.auditStatus == 1 || usrInfo.auditStatus == 4"
                v-model="legalName"
                placeholder="请输入法人名称"
              />
              <div v-else>{{ legalName || "--" }}</div>
            </a-form-item>
            <a-form-item
              class="mb-5"
              label="法人身份证"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                v-if="usrInfo.auditStatus == 1 || usrInfo.auditStatus == 4"
                v-model="legalCardNumber"
                placeholder="请输入法人身份证"
              />
              <div v-else>{{ legalCardNumber || "--" }}</div>
            </a-form-item>

            <a-form-item
              class="mb-5"
              label="公司地址"
              required
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-textarea
                v-if="usrInfo.auditStatus == 1 || usrInfo.auditStatus == 4"
                v-model="companyAddress"
                placeholder="请输入公司地址"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
              <div v-else>{{ companyAddress || "--" }}</div>
            </a-form-item>
            <a-form-item
              class="mb-5"
              v-if="usrInfo.auditStatus == 4"
              label="审核不通过理由"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <div>{{ remark || "--" }}</div>
            </a-form-item>
            <a-form-item
              v-if="usrInfo.auditStatus == 1 || usrInfo.auditStatus == 4"
              style="display: flex; justify-content: center"
            >
              <a-button
                type="primary"
                block
                html-type="submit"
                class="form-button"
                @click="handleSubmit"
              >
                {{ usrInfo.auditStatus == 1 ? "确认上传" : "重新上传" }}
              </a-button>
            </a-form-item>
            <div class="login_out_box">
              <div class="login_out_btn" @click="loginOut">重新登录</div>
            </div>
          </a-form>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import {
  logout,
  getUserAuditStatus,
  uploadDynamicReturnUrl,
  companyAdd,
} from "@/api/user";
import { setToken } from "@/utils/auth";
import Cookies from "js-cookie";
const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 10 },
};
const formTailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8, offset: 4 },
};
export default {
  props: {
    usrInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    usrInfo() {
      this.getUserAuditStatus();
    },
  },
  data() {
    return {
      stepStatus: "process",
      current: 0,
      checkNick: false,
      formItemLayout,
      formTailLayout,
      steps: [
        {
          title: "上传资料",
          content: "",
        },
        {
          title: "审核中",
          content: "",
        },
        {
          title: "审核结果",
          content: "",
        },
      ],
      loading: false,
      creditCode: "",
      companyName: "", //公司名称
      legalName: "", //
      legalCardNumber: "",
      companyAddress: "",
      businessLicense: "",
      remark: "",
    };
  },
  beforeCreate() {},
  created() {
    this.getUserAuditStatus();
  },
  methods: {
    getUserAuditStatus() {
      if (!this.usrInfo.companyId) {
        return;
      }
      getUserAuditStatus({ id: this.usrInfo.companyId }).then((res) => {
        if (this.usrInfo.auditStatus == 4) {
          this.steps[2] = {
            title: "审核不通过",
            content: "",
          };
          this.stepStatus = "error";
        } else {
          this.stepStatus = "process";
        }
        this.current =
          this.usrInfo.auditStatus == 1
            ? 0
            : this.usrInfo.auditStatus == 2
            ? 1
            : 2;

        this.creditCode = res.creditCode;
        this.companyName = res.companyName;
        this.legalName = res.legalName;
        this.legalCardNumber = res.legalCardNumber;
        this.companyAddress = res.companyAddress;
        this.businessLicense = res.businessLicense;
        this.remark = res.remark;
      });
    },

    handleSubmit() {
      if (!this.businessLicense) {
        this.$message.warning("请上传营业执照");
        return;
      }
      if (!this.creditCode) {
        this.$message.warning("请输入统一社会信用码/注册号/组织机构代码");
        return;
      }
      if (!this.companyName) {
        this.$message.warning("请输入公司名称");
        return;
      }
      if (!this.companyAddress) {
        this.$message.warning("请输入公司地址");
        return;
      }
      companyAdd({
        creditCode: this.creditCode,
        companyName: this.companyName, //公司名称
        legalName: this.legalName, //
        legalCardNumber: this.legalCardNumber,
        companyAddress: this.companyAddress,
        businessLicense: this.businessLicense,
      }).then((res) => {
        this.$message.success("上传成功");
        this.$emit("getInfo");
      });
    },

    handleChange(info) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", info.file);

      uploadDynamicReturnUrl(formData)
        .then((res) => {
          this.loading = false;
          this.businessLicense = res;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("You can only upload JPG file!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("Image must smaller than 2MB!");
      }
      return false;
    },

    loginOut() {
      logout()
        .then(() => {
          this.$store.dispatch("user/resetToken");
          localStorage.setItem("token", "");

          localStorage.setItem("userInfo", "");
          localStorage.removeItem("userInfo");
          Cookies.set("JavaInfo", "");
          setToken("");
          this.$router.replace({
            path: "/login",
          });
          // this.router.go(0);
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss">
.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
  color: #fff !important;
}
</style>

<style lang="scss" scoped>
.login_out_box {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  .login_out_btn {
    color: #0091fb;
    cursor: pointer;
  }
}

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
  border-radius: 10px !important;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.company {
  height: calc(100vh - 152px);
  margin-top: -40px;
  padding: 0px;
  overflow: hidden;
}
.sign_bg {
  position: fixed;
  height: 100vh;
  width: 100vw;
  left: 0;
}
.form-button {
  width: 200px;
  margin: 0 auto;
}
</style>
